import Phaser from 'phaser'

import Game from './scenes/Game'
import UI from './scenes/UI'
import GameOver from './scenes/GameOver'
import Intro from './scenes/Intro'
import LogoOverlay from './scenes/LogoOverlay'
import LevelTransitionVideo from './scenes/LevelTransitionVideo' 
import DailyRanking from './scenes/DailyRanking'

const ENEMIES_DECORATIVE_MODE = false
const CAN_STOMP_ENEMIES = false
const MUTE_LEVEL_MUSIC = false
const INTRO_ENABLED = true
const RANKING_REVIEW_MODE = false
const TARGET_FPS = 72
const DEFAULT_RANKING_API_BASE_URL = '/ranking/api/v1'

const resolveRankingApiBaseUrl = (): string => {
	const globalWindow = window as Window & {
		RANKING_API_BASE_URL?: string
		__RANKING_API_BASE_URL__?: string
	}

	const providedBaseUrl = typeof globalWindow.RANKING_API_BASE_URL === 'string' && globalWindow.RANKING_API_BASE_URL.trim().length > 0
		? globalWindow.RANKING_API_BASE_URL.trim()
		: (typeof globalWindow.__RANKING_API_BASE_URL__ === 'string' && globalWindow.__RANKING_API_BASE_URL__.trim().length > 0
			? globalWindow.__RANKING_API_BASE_URL__.trim()
			: DEFAULT_RANKING_API_BASE_URL)

	const normalizedBaseUrl = providedBaseUrl.replace(/\/+$/, '')

	if (/\/api\/v1$/i.test(normalizedBaseUrl))
	{
		return normalizedBaseUrl
	}

	return `${normalizedBaseUrl}/api/v1`
}

const GAME_SCENES = [Game, UI, GameOver, DailyRanking, LogoOverlay, LevelTransitionVideo, Intro]
const SCENES = RANKING_REVIEW_MODE
	? [DailyRanking, ...GAME_SCENES.filter(scene => scene !== DailyRanking)]
	: (INTRO_ENABLED ? [Intro, ...GAME_SCENES.filter(scene => scene !== Intro)] : GAME_SCENES)

const config: Phaser.Types.Core.GameConfig = {
	type: Phaser.AUTO,
	parent: 'game-container',
	pixelArt: true,
	antialias: false,
	roundPixels: false,
	fps: {
		target: TARGET_FPS,
		forceSetTimeOut: true
	},
	scale: {
		mode: Phaser.Scale.RESIZE,
		width: 600,
		height: 600
	},
	physics: {
		default: 'matter',
		matter: {
			debug: false
		}
	},
	callbacks: {
		preBoot: game => {
			game.registry.set('enemiesDecorativeMode', ENEMIES_DECORATIVE_MODE)
			game.registry.set('canStompEnemies', CAN_STOMP_ENEMIES)
			game.registry.set('muteLevelMusic', MUTE_LEVEL_MUSIC)
			const apiBaseUrl = resolveRankingApiBaseUrl()
			game.registry.set('rankingApiBaseUrl', apiBaseUrl)
		}
	},
	scene: SCENES
}

export default new Phaser.Game(config)
